export default __webpack_public_path__ + "static/N0104-6575bbde26efd88fff2f74ee91311fcf.png";